import React, { FC } from 'react';

import { TabProps } from '../tab.types';
import { Typography } from '../../../../../../components';
import { capitalize } from 'lodash';
import classNames from 'classnames';
import styles from './underline-tab.module.scss';

/**
 * Exclusively UnderlineTab component for Tab
 * @description UnderlineTab tab
 *
 * @author Rostyslav Nahornyi
 * @category Components
 * @param { TabProps } props - TabProps defined in the '../tab-props.types.ts'
 */
const UnderlineTab: FC<TabProps> = ({ label, isSelected, className, style, onClick, disabled }) => (
  <button
    tabIndex={0}
    aria-label={'button'}
    type={'button'}
    className={classNames(styles.settingsTab, isSelected && styles.selected, className)}
    style={style}
    onClick={onClick}
    disabled={disabled}
  >
    <Typography.Text variant={'bodyText1'} className={styles.title}>
      {capitalize(label)}
    </Typography.Text>
  </button>
);

export { UnderlineTab };
